import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Location } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-unauthorized',
  imports: [RouterModule],
  template: `
    <div class="of-error-page">
      <div
        class="card border shadow-sm bg-body overflow-hidden"
        style="--bs-card-border-radius: 0.9rem; max-width: 480px; width: 100%;"
      >
        <div class="card-header bg-transparent d-flex align-items-center gap-2 py-3">
          <i class="bi bi-shield-lock text-danger fs-5"></i>
          <h6 class="mb-0 fw-semibold">Access Restricted</h6>
        </div>
        <div class="card-body d-flex flex-column gap-3 py-4 px-4">
          <p class="text-muted mb-0 small">
            You do not have permission to view this page. If you believe this is a mistake, contact
            <a href="mailto:it-support@cigp.com" class="text-primary">it-support&#64;cigp.com</a>.
          </p>
          <div class="d-flex gap-2 mt-1">
            <button class="btn btn-sm btn-outline-secondary" (click)="goBack()">
              <i class="bi bi-arrow-left me-1"></i>Go Back
            </button>
            <a class="btn btn-sm btn-primary" routerLink="/"> <i class="bi bi-house me-1"></i>Home </a>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class UnauthorizedComponent {
  private readonly location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
